import { useTranslation } from "react-i18next";

function CompareWebsiteClosing({ mobile = false, compact = false, spacious = false, variant }) {
  const { t } = useTranslation();
  const line1Key = variant === "restaurants" ? "CompareWebsiteClosingRestaurants1" : "CompareWebsiteClosing1";
  const line2Key = variant === "restaurants" ? "CompareWebsiteClosingRestaurants2" : "CompareWebsiteClosing2";

  return (
    <p
      style={{
        marginTop: mobile ? 24 : compact ? (spacious ? 20 : 0) : 40,
        marginBottom: 0,
        marginLeft: compact ? "auto" : undefined,
        marginRight: compact ? "auto" : undefined,
        padding: mobile ? "0 16px" : compact ? "0 32px" : 0,
        width: "100%",
        maxWidth: compact ? 920 : undefined,
        textAlign: "center",
        fontSize: mobile ? 16 : compact ? 17 : 18,
        lineHeight: 1.45,
        fontStyle: "italic",
        color: "rgb(45, 55, 72)",
        boxSizing: "border-box",
        flexShrink: 0,
      }}
    >
      {t(line1Key)}
      {mobile ? <br /> : " "}
      {t(line2Key)}
    </p>
  );
}

export default CompareWebsiteClosing;
